export default {
  clean: () => import("/tmp/build_745d8f7f/layouts/clean.vue").then(m => m.default || m),
  default: () => import("/tmp/build_745d8f7f/layouts/default.vue").then(m => m.default || m)
}